import {
  LEAVEEMPLOYEES_FETCHING,
  LEAVEEMPLOYEES_SUCCESS,
  LEAVEEMPLOYEES_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LEAVEEMPLOYEES_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case LEAVEEMPLOYEES_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case LEAVEEMPLOYEES_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
